var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinSensorialExperienceDefaultLtr = function SvgPinSensorialExperienceDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.99 28.583c-5.445 0-9.86-4.366-9.86-9.752s4.415-9.753 9.86-9.753 9.859 4.366 9.859 9.753c0 5.386-4.414 9.752-9.86 9.752M36 0v25.4c0 29.923 4.723 46.119 14 74.6 9.276-28.481 14-44.677 14-74.6V0z"
  })));
};
export default SvgPinSensorialExperienceDefaultLtr;